import React from 'react';
import { Phone, MessageCircle, Mail, Instagram, MapPin } from 'lucide-react';

const ContactSection = ({ language }) => {
  const content = {
    de: {
      title: "Kontakt",
      subtitle: "Termine nur über WhatsApp oder Telefonanruf",
      phone: "Telefon",
      email: "E-Mail",
      instagram: "Instagram",
      address: "Adresse",
      appointmentNote: "Termine nur über WhatsApp oder Telefonanruf möglich."
    },
    en: {
      title: "Contact",
      subtitle: "Appointments via WhatsApp or phone call only",
      phone: "Phone",
      email: "Email", 
      instagram: "Instagram",
      address: "Address",
      appointmentNote: "Appointments via WhatsApp or phone call only."
    }
  };

  const handleCall = () => {
    window.location.href = 'tel:+491726060056';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/491726060056', '_blank');
  };

  const handleEmail = () => {
    window.location.href = 'mailto:rwanmaamo@gmail.com';
  };

  const handleInstagram = () => {
    window.open('https://instagram.com/rwan.cut', '_blank');
  };

  return (
    <section id="contact" className="py-16 lg:py-24 bg-primary">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-secondary mb-4">
            {content?.[language]?.title}
          </h2>
          <p className="font-body text-lg text-white/80 mb-2">
            {content?.[language]?.subtitle}
          </p>
          <p className="font-body text-sm text-secondary bg-secondary/10 px-4 py-2 rounded-lg inline-block">
            {content?.[language]?.appointmentNote}
          </p>
        </div>

        {/* Contact Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {/* Phone */}
          <button
            onClick={handleCall}
            className="bg-secondary/10 hover:bg-secondary/20 rounded-xl p-6 transition-luxury text-left group"
          >
            <div className="flex items-center space-x-4">
              <Phone size={24} className="text-secondary group-hover:scale-110 transition-luxury" />
              <div>
                <h3 className="font-body font-semibold text-white mb-1">
                  {content?.[language]?.phone}
                </h3>
                <p className="font-body text-secondary">
                  +49 172 6060056
                </p>
              </div>
            </div>
          </button>

          {/* WhatsApp */}
          <button
            onClick={handleWhatsApp}
            className="bg-secondary/10 hover:bg-secondary/20 rounded-xl p-6 transition-luxury text-left group"
          >
            <div className="flex items-center space-x-4">
              <MessageCircle size={24} className="text-secondary group-hover:scale-110 transition-luxury" />
              <div>
                <h3 className="font-body font-semibold text-white mb-1">
                  WhatsApp
                </h3>
                <p className="font-body text-secondary">
                  +49 172 6060056
                </p>
              </div>
            </div>
          </button>

          {/* Email */}
          <button
            onClick={handleEmail}
            className="bg-secondary/10 hover:bg-secondary/20 rounded-xl p-6 transition-luxury text-left group"
          >
            <div className="flex items-center space-x-4">
              <Mail size={24} className="text-secondary group-hover:scale-110 transition-luxury" />
              <div>
                <h3 className="font-body font-semibold text-white mb-1">
                  {content?.[language]?.email}
                </h3>
                <p className="font-body text-secondary">
                  rwanmaamo@gmail.com
                </p>
              </div>
            </div>
          </button>

          {/* Instagram */}
          <button
            onClick={handleInstagram}
            className="bg-secondary/10 hover:bg-secondary/20 rounded-xl p-6 transition-luxury text-left group"
          >
            <div className="flex items-center space-x-4">
              <Instagram size={24} className="text-secondary group-hover:scale-110 transition-luxury" />
              <div>
                <h3 className="font-body font-semibold text-white mb-1">
                  {content?.[language]?.instagram}
                </h3>
                <p className="font-body text-secondary">
                  @rwan.cut
                </p>
              </div>
            </div>
          </button>
        </div>

        {/* Address */}
        <div className="bg-secondary/10 rounded-xl p-6">
          <div className="flex items-start space-x-4">
            <MapPin size={24} className="text-secondary mt-1 flex-shrink-0" />
            <div>
              <h3 className="font-body font-semibold text-white mb-2">
                {content?.[language]?.address}
              </h3>
              <p className="font-body text-secondary">
                Hellweg 15<br />
                44787 Bochum, Germany
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;